import React from "react";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import FinalCTA from "../layouts/FinalCTA";
import { NavLink } from "react-router-dom";

const AboutUsPage = () => {

  const values = [
    {
      title: "Innovation First",
      desc: "We build modern mobile applications with future-ready technologies and scalable architecture.",
      icon: "🚀",
    },
    {
      title: "User Experience",
      desc: "Every app is crafted with premium UI/UX to maximize engagement and retention.",
      icon: "🎨",
    },
    {
      title: "Performance Driven",
      desc: "Fast loading, smooth animations and optimized mobile performance across every device.",
      icon: "⚡",
    },
    {
      title: "Long-Term Support",
      desc: "We continuously improve, scale and maintain apps after successful launch.",
      icon: "🔒",
    },
  ];

  const stats = [
    { number: "150+", label: "Apps Delivered" },
    { number: "10M+", label: "Downloads Generated" },
    { number: "4.9★", label: "Client Rating" },
    { number: "8+", label: "Years Experience" },
  ];

  const team = [
    {
      name: "UI/UX Experts",
      desc: "Creating engaging mobile experiences.",
    },
    {
      name: "App Developers",
      desc: "Building scalable Android & iOS apps.",
    },
    {
      name: "Backend Engineers",
      desc: "Powerful cloud & API architecture.",
    },
    {
      name: "QA Specialists",
      desc: "Delivering bug-free app experiences.",
    },
  ];

  return (
    <>
      <Header />
      <div className="about-page">

        {/* HERO */}
        <section className="about-hero">

          <div className="hero-glow hero-glow1"></div>
          <div className="hero-glow hero-glow2"></div>

          <div className="about-container">

            <div className="hero-content">

              <span className="hero-badge">
                ABOUT APPVERSELABS
              </span>

              <h1>
                We Build
                <span> World-Class </span>
                Mobile Apps
              </h1>

              <p>
                AppVerseLabs is a premium app development company
                focused on building high-performance iOS, Android
                and cross-platform mobile applications that users love.
              </p>

              <div className="hero-buttons">
                <NavLink to="/Contactus">
                  <button className="primary-btn">
                    Start Your Project
                  </button>
                </NavLink>
                <NavLink to="/Portfolio">
                  <button className="secondary-btn">
                    View Portfolio
                  </button>
                </NavLink>
              </div>
            </div>

            <div className="hero-card">

              <div className="floating-card">
                <span>🔥 Trending App Agency</span>
              </div>

              <div className="hero-main-card">

                <div className="hero-top">
                  <span>APPVERSELABS</span>
                  <div className="live-dot"></div>
                </div>

                <h3>Building Apps That Scale</h3>

                <p>
                  From startup MVPs to enterprise applications,
                  we deliver scalable mobile products globally.
                </p>

                <div className="hero-progress-wrap">

                  <div className="hero-progress-item">
                    <div className="hero-progress-head">
                      <span>Design</span>
                      <span>95%</span>
                    </div>

                    <div className="hero-progress-bar">
                      <div
                        className="hero-progress-fill"
                        style={{ width: "95%" }}
                      ></div>
                    </div>
                  </div>

                  <div className="hero-progress-item">
                    <div className="hero-progress-head">
                      <span>Development</span>
                      <span>98%</span>
                    </div>

                    <div className="hero-progress-bar">
                      <div
                        className="hero-progress-fill"
                        style={{ width: "98%" }}
                      ></div>
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* STATS */}
        <section className="about-stats">

          <div className="about-container stats-grid">

            {stats.map((item, index) => (
              <div className="stat-card" key={index}>
                <h3>{item.number}</h3>
                <p>{item.label}</p>
              </div>
            ))}

          </div>

        </section>

        {/* STORY */}
        <section className="story-section" style={{
          background:
            "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
          // padding: "56px 24px 52px",
          position: "relative",
          overflow: "hidden",

          animation: "fadeIn .6s .3s both",

        }}>

          <div className="about-container story-grid">

            <div className="story-left">

              <span className="section-tag">
                OUR STORY
              </span>

              <h2>
                A Mobile App Studio
                <span> Focused On Innovation</span>
              </h2>

              <p>
                At AppVerseLabs, we believe mobile apps should
                feel intuitive, fast and impactful. Our team
                combines creativity, strategy and engineering
                to create apps that stand out in the market.
              </p>

              <p>
                We work with startups, enterprises and growing
                brands to transform ideas into scalable digital
                products.
              </p>

            </div>

            <div className="story-right">

              <div className="story-box">
                <h3>10M+</h3>
                <span>Total App Downloads</span>
              </div>

              <div className="story-box">
                <h3>150+</h3>
                <span>Successful Projects</span>
              </div>

              <div className="story-box">
                <h3>25+</h3>
                <span>Expert Team Members</span>
              </div>

              <div className="story-box">
                <h3>Global</h3>
                <span>Clients Worldwide</span>
              </div>

            </div>

          </div>

        </section>

        {/* VALUES */}
        <section className="values-section" style={{
          background:
            "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
          // padding: "56px 24px 52px", 
          position: "relative",
          overflow: "hidden",

          animation: "fadeIn .6s .3s both",

        }}>

          <div className="about-container">

            <div className="section-heading">

              <span className="section-tag">
                WHY CHOOSE US
              </span>

              <h2 style={{ textAlign: "center", }}>
                Built Around
                <span> Excellence</span>
              </h2>

            </div>

            <div className="values-grid">

              {values.map((item, index) => (
                <div className="value-card" key={index}>

                  <div className="value-icon">
                    {item.icon}
                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.desc}</p>

                </div>
              ))}

            </div>

          </div>

        </section>

        {/* TEAM */}
        <section className="team-section" style={{
          background:
            "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
          // padding: "56px 24px 52px",
          position: "relative",
          overflow: "hidden",

          animation: "fadeIn .6s .3s both",

        }}>

          <div className="about-container">

            <div className="section-heading">

              <span className="section-tag">
                OUR TEAM
              </span>

              <h2 style={{ textAlign: "center", }}>
                Experts Behind
                <span> AppVerseLabs</span>
              </h2>

            </div>

            <div className="team-grid">

              {team.map((item, index) => (
                <div className="team-card" key={index}>

                  <div className="team-avatar">
                    {index + 1}
                  </div>

                  <h3>{item.name}</h3>

                  <p>{item.desc}</p>

                </div>
              ))}

            </div>

          </div>

        </section>

        <FinalCTA />

      </div>
      <Footer />

    </>
  );
};

export default AboutUsPage;